import type { Entity } from '@models/Entity'

import { apiClient } from '../../../gateways/api'
import type { AssignedBijlage } from '../types/AssignedBijlage'
import type { AssignedBijlagenForEntity } from '../types/AssignedBijlagenForEntity'

export { fetchAssignedBijlagenForEntity, initialState }

const initialState: AssignedBijlagenForEntity = {
  data: [],
}

const fetchAssignedBijlagenForEntity = async ({
  id,
  type,
}: Entity): Promise<AssignedBijlage[]> => {
  const { data } = await apiClient({
    url: `/rest/${type}/${id}/bijlageassigned`,
    method: 'GET',
  })
  return data
}
